import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteStaffInfoList } from "../Actions/StaffManagementAPI";
import { confirmAlert } from 'react-confirm-alert';

class StaffManagementDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: ""
        }
    }

    ShowSidePanel = () => {
        this.setState({ showSidePane: false })
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/Staff");
    }

    render() {
        const { StaffDetails } = this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row">
                        <div className={`${StaffDetails.name !== null ? " " : "p-none "}col-lg-12`}>
                            <div className={`${StaffDetails.name !== null ? "row " : "w-100 "}resource-list-auth-date`}>
                                <div className="panel-box search-filter-box">
                                    <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" onClick={() => this.ShowSidePanel()}>&larr; Return</button>
                                    <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                        <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Staff Details</h5>
                                        </div>
                                        <div className="pt-3 pb-3 search-filter-box">
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <label className="form-label" >Name :</label>
                                                    <span>{" "}{StaffDetails.name}</span>
                                                </div>
                                                <div className="col-sm-6">
                                                    <label className="form-label" >Email :</label>
                                                    <span>{" "}{StaffDetails.email}</span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Phone 1 :</label>
                                                    <span>{" "}{StaffDetails.phone1}</span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label className="form-label" >Phone 2 :</label>
                                                    <span>{" "}{StaffDetails.phone2}</span>
                                                </div>
                                                <div className="col-sm-12">
                                                    <label className="form-label" >Address :</label>
                                                    <span>{" "}{StaffDetails.address}</span>
                                                </div>
                                                {/* <div className="col-sm-12">
                                                    <label className="form-label" >Ship Name :</label>
                                                    <span>{" "}{StaffDetails.shipName}</span>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 pb-2 pt-2">
                                            <div className="search-btn-col mt-1" style={{ textAlign: "right" }}>
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.EditStaffDetails(StaffDetails)}>
                                                    {" "}Edit{" "}
                                                </button>
                                                <button
                                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                    type="button" onClick={() => this.DeleteStaffDetails(StaffDetails)}> {" "}Delete{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
    EditStaffDetails(item) {
        this.props.history.push(`/Home/Management/StaffEdit/${item.staffId}`);
        this.props.dispatch({ type: "StaffDetails", data: item });
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }
    DeleteStaffDetails(item) {
        const { pagesearch } = this.props;
        let staffinfo = {
            staffId: item.staffId,
            name: item.name,
            phone1: item.phone1,
            phone2: item.phone2,
            email: item.email,
            address: item.address,
            isDeleted: true,
            modifiedBy: "",
        }
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.props.dispatch(deleteStaffInfoList(staffinfo));
                        this.props.dispatch({ type: "ShowSidePan", data: false });
                        this.props.history.goBack();
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        StaffDetails: state.MasterScreenReducer.StaffDetails,
        pagesearch: state.MasterScreenReducer.pagesearch
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffManagementDetail));